<template>
  <router-link
    :class="$root.listItemClasses + ' puzzle-list-item'"
    :to="{
      name: 'puzzle',
      params: {
        puzzleId: puzzle.id
      }
    }"
  >
    {{ puzzle.name }}
    <span
      class="badge badge-primary"
    >
      {{ $root.displayDateLocalFmt( puzzle.date ) }}
    </span>
    <span
      v-if="!puzzle.public"
    >
      🕶
    </span>
  </router-link>
</template>
<script>
export default {
  props: {
    noKey: {
      type: Boolean,
      default: false
    },

    puzzle: {
      type: Object,
      default: () => {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PuzzleListItem.vue